import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ConfirmationDialog({
  title,
  body,
  okButtonText,
  open,
  handleClose,
  cb
}: {
  title: string;
  body: string;
  okButtonText: string;
  open: boolean;
  handleClose: () => void;
  cb: () => void;
}) {
  const handleOkClick = () => {
    handleClose();
    cb();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>peru</Button>
        <Button onClick={handleOkClick} autoFocus>
          {okButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
